export default "__VITE_ASSET__u5r_kprR__"